import React, { useMemo } from "react";
import classNames from "classnames";
import { Account } from "@common/types/domains/accounting/account";
import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { ColumnDef } from "@components/spreadsheet/types";
import jeStyles from "@components/accounting/journalEntryDrawer/JournalEntryDrawer.module.scss";
import { EliminatingEntryLineForm } from "./eliminatingEntryDrawer.lib";
import {
    applyEliminatingGridChange,
    toEliminatingGridData,
} from "./eliminatingEntryGridData";

interface Props {
    lines: EliminatingEntryLineForm[];
    columns: ColumnDef[];
    gridTemplateColumns: string;
    accountsById: Record<string, Account>;
    accountsByEntityId: Record<number, Account[]>;
    readonly?: boolean;
    onLinesChange: (lines: EliminatingEntryLineForm[]) => void;
}

export const EliminatingEntryGrid: React.FC<Props> = ({
    lines,
    columns,
    gridTemplateColumns,
    accountsById,
    accountsByEntityId,
    readonly = false,
    onLinesChange,
}) => {
    const data = useMemo(() => toEliminatingGridData(lines), [lines]);

    return (
        <SpreadsheetGrid
            data={data}
            columns={columns}
            onChange={
                readonly
                    ? undefined
                    : (newData, changedCells) =>
                          onLinesChange(
                              applyEliminatingGridChange({
                                  newData,
                                  changedCells,
                                  columnFields: columns.map(
                                      ({ field }) => field,
                                  ),
                                  priorLines: lines,
                                  accountsById,
                                  accountsByEntityId,
                              }),
                          )
            }
            className={classNames(
                jeStyles.spreadsheet,
                jeStyles.editableSpreadsheet,
            )}
            gridTemplateColumns={gridTemplateColumns}
            stickyHeader
            showTotalsRow
            noOuterBorder
            overflow="auto"
            lightNotEditableCells
            readonly={readonly}
        />
    );
};
